import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import AuthProvider from "./auth/AuthProvider";
import Layout from "./components/Layout/Layout";
import Home from "./pages/Home";
import Customers from "./pages/Customers";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Tracks from "./pages/Tracks";
import TrackDetails from "./pages/TrackDetails";
import EditTrack from "./pages/EditTrack";
import AddCoursesToTrack from "./pages/AddCoursesToTrack";
import TenantGroupsPage from "./pages/TenantGroupsPage";
import SystemTools from "./pages/SystemTools";
import Login from "./pages/Login";
import ConsentCallback from "./pages/ConsentCallback";
import AdminConsentCallback from "./pages/AdminConsentCallback";

/**
 * Main App component
 */
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Special routes that don't require authentication */}
          <Route path="/consent-callback" element={<ConsentCallback />} />
          <Route path="/auth/admin-consent-callback" element={<AdminConsentCallback />} />
          
          {/* Authenticated routes */}
          <Route path="/" element={
            <AuthenticatedTemplate>
              <Layout>
                <Home />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/customers" element={
            <AuthenticatedTemplate>
              <Layout>
                <Customers />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/reports" element={
            <AuthenticatedTemplate>
              <Layout>
                <Reports />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/users" element={
            <AuthenticatedTemplate>
              <Layout>
                <Users />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/tracks" element={
            <AuthenticatedTemplate>
              <Layout>
                <Tracks />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/tracks/:trackId" element={
            <AuthenticatedTemplate>
              <Layout>
                <TrackDetails />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/tracks/:trackId/edit" element={
            <AuthenticatedTemplate>
              <Layout>
                <EditTrack />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/tracks/:trackId/add-courses" element={
            <AuthenticatedTemplate>
              <Layout>
                <AddCoursesToTrack />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/customer/:customerId/tenant-groups" element={
            <AuthenticatedTemplate>
              <Layout>
                <TenantGroupsPage />
              </Layout>
            </AuthenticatedTemplate>
          } />
          <Route path="/system-tools" element={
            <AuthenticatedTemplate>
              <Layout>
                <SystemTools />
              </Layout>
            </AuthenticatedTemplate>
          } />
          
          {/* Fallback route */}
          <Route path="*" element={
            <AuthenticatedTemplate>
              <Layout>
                <Navigate to="/" replace />
              </Layout>
            </AuthenticatedTemplate>
          } />
        </Routes>
        
        {/* Login page for unauthenticated users */}
        <UnauthenticatedTemplate>
          <Login />
        </UnauthenticatedTemplate>
      </Router>
    </AuthProvider>
  );
};

export default App;
